import { FC, ReactNode, useEffect, useRef } from 'react';
import { Spin } from '../Spin';

interface IProps {
  id?: string;
  wrapperClassName?: string;
  isLoading: boolean;
  hasMore: boolean;
  loadMore: () => void;
  children: ReactNode;
  loader?: ReactNode;
}

export const Scroller: FC<IProps> = (props) => {
  const {
    wrapperClassName = '',
    loadMore,
    isLoading = false,
    hasMore,
    children,
    loader,
  } = props;

  const targetRef = useRef(null);

  useEffect(() => {
    if (isLoading || !hasMore || !targetRef.current) {
      return;
    }
    const target = targetRef.current;
    const io = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (hasMore && entry.isIntersecting) {
        loadMore();
      }
    });
    io.observe(target);
    return () => io.disconnect();
  }, [isLoading, hasMore]);

  return (
    <div className={wrapperClassName}>
      {children}
      <div ref={targetRef}>
        {loader || (
          <div className="flex justify-center items-center h-12 text-sm text-secondary-3">
            {isLoading || hasMore ? (
              <span className="flex items-center gap-2">
                <Spin width={18} height={18} />
                加载中...
              </span>
            ) : (
              <p className="mt-10"> —— 已显示全部内容 ——</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
